import { Card } from "@components/ui-kit";
import { t } from "@lingui/macro";
import { useInvoiceDetailStore } from "@src/components/modules/invoices/Detail/store";
import { observer } from "mobx-react-lite";
import { CardTitle } from "../common";
import { TimeBillingList } from "./time-billing-list";

export const TimeBillingCard = observer(function TimeBillingCard() {
  const store = useInvoiceDetailStore();

  if (!store.invoice?.projectTimeBilling) return null;

  return (
    <Card>
      <Card.Section>
        <CardTitle>{t`Time Billing`}</CardTitle>
        <TimeBillingList />
      </Card.Section>
    </Card>
  );
});
